// extracted by css-extract-rspack-plugin
export default {"input":"input-I3R42U"};